import { IPlaceholder } from '../../interface/Placeholder'

export const defaultPlaceholderOption: Readonly<Required<IPlaceholder>> = {
  data: '',
  color: '#DCDFE6',
  opacity: 1,
  size: 16,
  font: 'Microsoft YaHei'
}
